export const IS_DEV = import.meta.env.MODE === "development"
